<template>
  <div class="container-yard-home">
    <van-notice-bar left-icon="volume-o" :scrollable="false">
      <van-swipe vertical class="notice-swipe" :autoplay="10000" :show-indicators="false">
        <van-swipe-item>落箱送积分了！</van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <h2 style="color: #d81e06">千里码落箱</h2>
    <!--<h2 style="color: #d81e06">元升落箱</h2>-->
    <van-row type="flex" justify="center">
      <van-col span="20">
        <van-button plain to="/container-yard/in">自助落箱</van-button>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center">
      <van-col span="20">
        <van-button plain to="/container-yard/out">自助提箱</van-button>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center">
      <van-col span="20">
        <van-button plain to="/container-yard/billList">落箱凭证</van-button>
      </van-col>
    </van-row>

    <p></p>
    <van-cell-group>
      <van-cell title="可用积分" :value="this.point" @click="goWalletLog()" is-link/>
    </van-cell-group>
    <tabbar :selected="selected"></tabbar>
  </div>
</template>

<script>
import tabbar from '@/components/tabbar'

export default {
  components: {tabbar},
  data() {
    return {
      selected: "box",
      point: 0,
    };
  },
  methods: {
    getWallet() {
      let querystring = require('querystring');
      this.$api.post("/wx/user/wallet",
          querystring.stringify({
            mobile: localStorage.getItem("tel"),
          })
      ).then(data => {
        if (data.data.status == 1) {
          this.point = data.data.data.point_balance;
        } else {

        }
      }).catch(err => {
        console.log(err);
      });
    },
    goWalletLog() {
      this.$router.push("/wallet_log");
    },
    getBillList() {

    }
  },
  mounted() {
    this.getWallet();
  }
}
</script>

<style lang="less" scoped>
.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.container-yard-home .van-cell {
  text-align: left;
}

.van-row {
  margin: 1rem;
}

.van-button {
  height: 3rem;
  width: 6rem;
  font-size: 0.7rem;
}
</style>


// WEBPACK FOOTER //
// src/components/container-yard/home.vue